import { useT } from "../../../i18n";
import { mmss } from "../lib/script";
import type { ScriptState } from "../types";

/**
 * FS-13-02 학생 측 단계 표시(SCR v0.6 sfs-13 하단 · SR-TCH-03) — 룸 화면 상단 바 아래 한 줄.
 *  - 단계 칩(아이콘 + 이름 · 지금 단계 노랑 강조 · 지난 단계 흐림) · 오른쪽에 지금 단계 남은 시간
 *  - SE: 아이콘 + 한 단어 · 학생 조작 없음(버튼 없음) · 점수·순위 없음(DR-01)
 *  - 스크립트가 멈췄으면 시간 앞에 ⏸(탓하지 않는 중립 표시) · 끝났거나 없으면 그리지 않는다
 * 교사 스크립트 화면(FS-13-01)은 같은 조각을 '학생 화면 미리보기'로 쓴다.
 */
export function StudentScriptBar({
  script,
  leftS,
  se,
  testId = "fs-13-02",
}: {
  script: ScriptState | null;
  leftS: number | null;
  se: boolean;
  testId?: string;
}) {
  const t = useT();
  if (!script || script.done) return null;
  return (
    <nav
      className="pf-script-bar"
      aria-label={t("script.barLabel")}
      data-testid={testId}
      data-running={script.running}
    >
      <ol className="pf-script-bar__steps">
        {script.steps.map((s, i) => {
          const state = i < script.index ? "done" : i === script.index ? "now" : "next";
          return (
            <li
              key={`${s.key}-${i}`}
              className="pf-script-bar__step"
              data-state={state}
              data-step={s.key}
              aria-current={state === "now" ? "step" : undefined}
            >
              <span aria-hidden="true">{s.icon}</span>
              {t(se ? `script.stepShort.${s.key}` : `script.step.${s.key}`)}
            </li>
          );
        })}
      </ol>
      <b
        className="pf-script-bar__left"
        data-testid={`${testId}-left`}
        aria-label={t("script.leftLabel", { left: mmss(leftS ?? 0) })}
      >
        {!script.running && <span aria-hidden="true">⏸ </span>}
        {mmss(leftS ?? 0)}
      </b>
    </nav>
  );
}
